
import { Component, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { SelectBoxComponent } from '@app/customizer/components/select-box/select-box';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantModel } from '@models/component-variant';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ImageService } from '@services/image.service';
import { ComponentVariantFromApiModel } from '../../../../_models/api-models/component-variant-fromapi';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { SorterService } from '../../../../_services/sorter.service';
import { PreciousFinishService } from '../precious-finish.service';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    selector: 'bridge-design',
    template: `
  <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)" [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.BRIDGEDESIGN.NAME'">
    @if (designs.length) {
      <select-box
        [imageClass]="'bridge'"
        [optionsImage]="getImage"
        [options]="designs"
        [editMode]="state === customizerStateEnum.EDITORDER"
        optionsText="Description"
        optionsId="Id"
        [selected]="getSelectedVariant"
        (selectedChange)="onSelect($event)"
        [optionsDiscontinued]="'Discontinued'"
        (matchColors)="matchColors(null)"
        [colorMatchMode]="true"
        [colorsAvailableForMatching]="allPossibleColorsOnOtherSelectedVariants"
        [currentColor]="getSelectedVariant.VariantColor"
        [variantOrModelIsNew]="modelIsNew"
        [matchColor]="menu.matchColor"
      ></select-box>
    }
  </customizer-component-header>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, SelectBoxComponent]
})
export class BridgeDesignComponent extends BaseCustomizerComponent implements OnInit {

	public designs: Array<ComponentVariantFromApiModel> = [];
	public variant: ComponentVariantModel;

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public imageService: ImageService,
		public sorter: SorterService,
		private preciousFinishService: PreciousFinishService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		this.events.showLoader(true);
		await this.fetchData();
		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
	}

	getImage = (variant: ComponentVariantFromApiModel) => this.imageService.GetVariantImage(variant.ToComponentVariantModel());

	onSelect(selectedTemple: ComponentVariantFromApiModel) {
		this.events.showLoader(true);

		const current = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const selectedMapped = selectedTemple.ToComponentVariantModel("", this.getSelectedVariant.OrderLineUuid, true);

		// ##### GROSS HACK to glue whatever finish selected in the Finish menu (based on the temple component) to the selected nosepad
		let templeComponent = this.variants.find(v => v.Code.includes(';') && v.Component.Code === 'TEMPLE');
		if (templeComponent) {
			let templeFinish = templeComponent?.Code.substring(templeComponent.Code.indexOf(';'));

			if (templeFinish) {
				selectedMapped.Code = selectedMapped.Code + templeFinish;
				selectedMapped.Description2 = templeComponent.Description2;
			}
		}

		this.updateVariantDesign(new ComponentVariantChangeModel(current, selectedMapped, selectedTemple.VariantSizes));
	}

	async fetchData() {
		const variant = this.getSelectedVariant;

		if (variant) {
			variant.VariantViewed = true;

			const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, variant.Component.Uuid);
			await this.RunDisablingSystem(apidata);

			let newList = apidata;

			if (apidata?.some(cv => cv.Code.includes(';'))) {
				newList = this.preciousFinishService.removeDuplicates(apidata);
			}

			this.designs = newList?.filter(x => !x.isDisabled).sort(this.sorter.sortBy(ComponentVariantFromApiModel)) ?? [];
		}
	}

}
